var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAttachedSingleFamily = function SvgAttachedSingleFamily(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 41 41"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.043 37.606V3.59H21.73v34.016M3.043 3.59V1H21.73v2.59m0 34.017V11.715h16.577v25.892"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M26.512 37.604V29.95c0-1.74 1.57-3.153 3.506-3.153 1.936 0 3.506 1.412 3.506 3.153v7.654"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1 40.317h39.346v-2.712H1v2.712z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.73 8.48h16.578m-14.105 2.823V8.781m2.617 2.522V8.781m2.618 2.522V8.781m2.617 2.522V8.781m2.617 2.522V8.781m2.621 2.522V8.781"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M24.57 22.35h3.984v-5.635H24.57v5.636zm6.91 0h3.985v-5.635H31.48v5.636zM6.934 12.933h3.984V7.297H6.934v5.636zm6.914 0h3.984V7.297h-3.984v5.636zM6.934 22.35h3.984v-5.635H6.934v5.636zm6.914 0h3.984v-5.635h-3.984v5.636z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.46 32.805v4.624"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.457 29.846a2.96 2.96 0 1 1-5.918 0 2.96 2.96 0 0 1 5.918 0z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.23 32.805v4.624"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.227 29.846a2.96 2.96 0 1 1-5.918 0 2.96 2.96 0 0 1 5.918 0z",
    clipRule: "evenodd"
  })));
};
export default SvgAttachedSingleFamily;